module.exports = __webpack_public_path__ + "static/media/alineLogo.bc49c49d.png";